import { Link } from "react-router-dom";

import { Layout } from "@/components/layout";

export function NotFound() {
  return (
    <Layout>
      <section className="mx-auto max-w-4xl px-8 pt-20 pb-16">
        <p className="text-[11px] text-text-muted tracking-wide-caps uppercase mb-6">Error 404</p>
        <h1 className="text-[44px] font-bold text-primary leading-[1.15] mb-4 tracking-tight">
          Page Not Found
        </h1>
        <p className="text-[15px] text-text-secondary leading-relaxed max-w-lg mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-primary text-primary-foreground font-bold text-[14px] hover:opacity-90 transition-opacity"
        >
          Return Home
        </Link>
      </section>
    </Layout>
  );
}
